import React from 'react';
import ProtectionPlanIcon from "@/assets/icons/ProtegaOffers/ProtectionPlan.svg?react";
import ClaimsProcessingIcon from "@/assets/icons/ProtegaOffers/ClaimsProcessing.svg?react";
import FraudPreventionIcon from "@/assets/icons/ProtegaOffers/FraudPrevention.svg?react";
import ReturnsExchangesIcon from "@/assets/icons/ProtegaOffers/Returns&Exchanges.svg?react";
import RevenueGrowthIcon from "@/assets/icons/ProtegaOffers/RevenueGrowth.svg?react";
import AnalyticsInsightsIcon from "@/assets/icons/ProtegaOffers/Analytics&Insights.svg?react";

const offers = [
  {
    title: "Protection Plans",
    description: "Cover failures & accidental damage",
    icon: <ProtectionPlanIcon className="tw-w-16 tw-h-16"/>,
  },
  {
    title: "AI Claims Processing",
    description: "Resolve claims in seconds",
    icon: <ClaimsProcessingIcon className="tw-w-16 tw-h-16" />,
  },
  {
    title: "Fraud Prevention",
    description: "Detect and stop misuse early",
    icon: <FraudPreventionIcon className="tw-w-16 tw-h-16" />,
  },
  {
    title: "Returns & Exchanges",
    description: "Smooth post-purchase flows",
    icon: <ReturnsExchangesIcon className="tw-w-16 tw-h-16" />,
  },
  {
    title: "Revenue Growth",
    description: "Earn from every plan sold",
    icon: <RevenueGrowthIcon className="tw-w-16 tw-h-16" />,
  },
  {
    title: "Analytics & Insights",
    description: "Optimize performance with data",
    icon: <AnalyticsInsightsIcon className="tw-w-16 tw-h-16" />,
  },
];

const ProtegaOffers: React.FC = () => {
  return (
    <section className="tw-py-20 tw-bg-black">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-6">
        {/* Header */}
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-4xl md:tw-text-5xl lg:tw-text-6xl tw-font-bold tw-mb-4 tw-text-white">
            What <span className="tw-text-[#00C5FB]">Protega Offers</span>
          </h2>
          <p className="tw-text-gray-400 tw-text-base md:tw-text-lg tw-max-w-2xl tw-mx-auto">
            Everything you need to protect, automate, and grow post-purchase experiences.
          </p>
        </div>

        {/* Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6 tw-auto-rows-stretch">
          {offers.map((offer, index) => (
            <div 
              key={index}
              className="tw-relative tw-rounded-[2rem] tw-transition-all tw-duration-1000 tw-h-full"
              /* Gradient border commented out for now: tw-p-[1px] tw-bg-gradient-to-b tw-from-[#00C5FB]/40 tw-to-transparent hover:tw-from-[#00C5FB]/70 */
            >
              {/* Persistent strong halo effect behind the card */}
              <div className="tw-absolute tw-inset-0 tw-bg-[#00C5FB]/20 tw-blur-[60px] tw-transition-all tw-duration-1000" />

              <div 
                className="tw-group tw-relative tw-p-8 tw-py-10 tw-rounded-[1.95rem] tw-bg-black tw-transition-all tw-duration-700 tw-flex tw-flex-col tw-items-center tw-text-center tw-overflow-hidden tw-shadow-[0_0_25px_rgba(0,197,251,0.05)] tw-h-full"
              >
                {/* Centered radial glow on hover */}
                <div className="tw-absolute tw-inset-0 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-700 tw-bg-[radial-gradient(circle_at_center,_rgba(0,197,251,0.2)_0%,_transparent_70%)]" />
                
                {/* Content */}
                <div className="tw-relative tw-z-10 tw-flex tw-flex-col tw-items-center tw-h-full">
                  <div className="tw-mb-6">
                    {offer.icon}
                  </div>
                  <h3 className="tw-text-2xl tw-font-bold tw-text-white tw-mb-3">
                    {offer.title}
                  </h3>
                  <p className="tw-text-gray-400 tw-text-base tw-leading-relaxed tw-max-w-[280px] tw-mx-auto tw-flex-grow">
                    {offer.description}
                  </p>
                </div>

                {/* Bottom accent glow */}
                <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-[2px] tw-bg-gradient-to-r tw-from-transparent tw-via-[#00C5FB]/0 group-hover:tw-via-[#00C5FB]/50 tw-to-transparent tw-transition-all tw-duration-1000" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProtegaOffers;
